


























import { Component } from 'vue-property-decorator'

import FoldingCard from '@/components/FoldingCard.vue'
import detail from '@/modules/Quote/views/detail.vue'

@Component({
  components: {
    FoldingCard
  }
})
export default class QuoteDetailSource extends detail {
  routeToProducerDetail () {
    return {
      name: 'ProducerDetailDetail',
      params: {
        id: this.quote.source.id + ''
      }
    }
  }
}
